export class MidiaEnum {
    static INTERNET = 1;
    static MOBILE = 2;
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/enumaration/midiaEnum.ts